export default "__VITE_ASSET__HeS0Mbdw__"